export default __webpack_public_path__ + "static/media/Foto24.1c45f475.png";